import {Brick, registerBrick} from 'olympe';

/**
 * The add method of Set instances inserts a new element into a Set.
 */
export default class AddInSet extends Brick {
    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {Set} set
     * @param {any} value
     * @param {function()} forwardEvent
     * @param {function(Set)} setSet
     */
    update($, [set, value], [forwardEvent, setSet]) {
        set.add(value);
        setSet(set);
        forwardEvent();
    }
}

registerBrick('018a6f10f2e2f5ffd5ef', AddInSet);
